import { InjectionToken } from '@angular/core';

export const IdealSearchFieldPlaceholder = new InjectionToken<string>('IdealSearchFieldPlaceholder', {
  factory: () => $localize`:@@AppQuickSearch_SearchFieldPlaceholder:Search`,
});
